/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import _ from "lodash";
import React from "react";
import { getUpdatedOptionsList } from "../../../../utils/optionsList";
import CheckBox from "../../../shared-ui/checkbox";
import WhyAskingPopup from "../../../shared-ui/popup/why-asking-popup";
import WhyAskingComponent from "../../../shared-ui/why-asking";
import {
  setUserResponse,
  getPreFillDataByContentKey,
} from "../../../../utils/userResponse";
import { setProfileCustomAttribute } from "../../../../services/suggesticServices";

// Interface Ranking Selection Component Props
interface RankingSelectionComponentProps {
  questionTitle: string;
  questionSubTitle?: string;
  errorMsg: any;
  whyQuestionList: [];
  listOfAnswers: string[];
  handleChildContinue?: any;
  handleSuccessfulContinue: any;
  recoId: any;
  contentTypeId: any;
  position: any;
  cmDependent: any;
  t?: any;
}

// Interface Ranking Selection Component state
interface RankingSelectionComponentState {
  errorMsg?: string;
  isPopupOpen: boolean;
  optionsList: any;
  selectedValues: any;
  isError: boolean;
  questionTitleState: string;
}

/**
 * Used for any answer type is in a Ranking Selection.
 *
 * @namespace RankingSelectionComponent
 */

class RankingSelectionComponent extends React.Component<
  RankingSelectionComponentProps,
  RankingSelectionComponentState
> {
  constructor(props: RankingSelectionComponentProps) {
    super(props);
    this.state = {
      isPopupOpen: false,
      optionsList: [],
      selectedValues: [],
      isError: false,
      questionTitleState: "",
    };
  }

  componentDidMount = () => {
    this.props.handleChildContinue(this.handleError);
    let recoValuesData: any = getPreFillDataByContentKey(
      this.props.contentTypeId
    );
    if (recoValuesData && !_.isEmpty(recoValuesData)) {
      this.setPreFillData(recoValuesData);
    } else {
      const data: any = getUpdatedOptionsList(this.props.listOfAnswers);
      data &&
        data.forEach(function (item: {
          isChecked: boolean;
          isDisabled: boolean;
        }) {
          item.isChecked = false;
          item.isDisabled = false;
        });
      this.setState({
        optionsList: data,
        questionTitleState: this.props.questionTitle,
      });
      localStorage.setItem("NeedStateData", JSON.stringify(data));
    }
  };

  // componentDidUpdate = () => {
  //   const { listOfAnswers } = this.props;
  //   const { optionsList } = this.state;
  //   const data: any = getUpdatedOptionsList(listOfAnswers);
  //   data &&
  //     data.forEach(function (item: {
  //       isChecked: boolean;
  //       isDisabled: boolean;
  //     }) {
  //       item.isChecked = false;
  //       item.isDisabled = false;
  //     });
  //   let listOfAnswersProps = data.map(function (element: any) {
  //     return element.value;
  //   });
  //   let listOfAnswersState = optionsList.map(function (element: any) {
  //     return element.value;
  //   });
  //   const equal = _.isEqual(listOfAnswersProps, listOfAnswersState);
  //   if (!equal) {
  //     this.setState({
  //       optionsList: data,
  //       isError: false,
  //       selectedValues: [],
  //       // displayBanner: false,
  //     });
  //   }
  // };

  componentDidUpdate = () => {
    const { listOfAnswers } = this.props;
    const data: any = getUpdatedOptionsList(listOfAnswers);
    data &&
      data.forEach(function (item: {
        isChecked: boolean;
        isDisabled: boolean;
      }) {
        item.isChecked = false;
        item.isDisabled = false;
      });

    if (this.props.questionTitle !== this.state.questionTitleState) {
      this.setState({
        optionsList: data,
        isError: false,
        selectedValues: [],
        questionTitleState: this.props.questionTitle,
      });
      let recoValuesData: any = getPreFillDataByContentKey(
        this.props.contentTypeId
      );
      if (recoValuesData) {
        this.setPreFillData(recoValuesData);
      }
    }
    localStorage.setItem("NeedStateData", JSON.stringify(data));
  };

  /**
   * Used to set data as per users input(existing- if any)
   */
  setPreFillData = (recoValuesData: any) => {
    const data: any = getUpdatedOptionsList(this.props.listOfAnswers);
    let selectedNeedStates: any = [];
    _.map(data, (item: any, index: any) => {
      item.isDisabled = false;
      if (recoValuesData?.recoValues?.length === 3) {
        item.isDisabled = true;
      }
      if (_.includes(recoValuesData.recoValues, item.id)) {
        item.isChecked = true;
        item.isDisabled = false;
        let indexOfItem = recoValuesData?.recoValues?.indexOf(item.id);
        selectedNeedStates[indexOfItem] = item;
      } else {
        item.isChecked = false;
      }
    });
    this.setState({
      optionsList: data,
      selectedValues: !_.isEmpty(selectedNeedStates) ? selectedNeedStates : [],
    });
  };

  /**
   * This method is used for handling error
   *
   */

  handleError = () => {
    const { optionsList } = this.state;
    const { position } = this.props;
    const positionIntoInt = parseInt(position);
    const filteredOptions = optionsList.filter(
      (obj: any) => obj.isChecked === false
    ).length;
    if (filteredOptions === optionsList.length) {
      this.setState({
        isError: true,
        // displayBanner: true,
      });
    } else {
      this.setState(
        {
          isError: false,
          // displayBanner: false,
        },
        () => {
          this.getSelectedData();
          //suggestic call for setting custom attributes
          setProfileCustomAttribute();
          let needStates: any = [];
          this.state.selectedValues.forEach((element: any) => {
            needStates.push(element && element.needStateId);
          });
          needStates = _.compact(needStates);
          let finalNeedStates = needStates.filter(
            (x: any) => x !== "not_available"
          );
          if (this.props.cmDependent) {
            const addRemoveData = this.handleAddRemoveCm();
            this.props.handleSuccessfulContinue(
              finalNeedStates,
              positionIntoInt,
              false,
              false,
              true,
              addRemoveData.valuesToAdd,
              addRemoveData.valuesToRemove
            );
          } else {
            this.props.handleSuccessfulContinue(
              finalNeedStates,
              positionIntoInt,
              false
            );
          }
        }
      );
    }
  };

  /**
   *
   * handleAddRemoveCm -- data to remove or add
   */
  handleAddRemoveCm = () => {
    const cmDepList: any = this.props.cmDependent;
    const data: any = this.getSelectedData();
    const selectedValue = data?.recoValues;
    let valuesToAdd: any = [];
    let valuesToRemove: any = [];
    _.map(cmDepList, (eachData: any) => {
      if (!_.isEmpty(eachData)) {
        let newArray = _.intersection(eachData.conditions, selectedValue);
        console.log("");
        let isCmValueFound: boolean =
          newArray?.length > 0 && selectedValue?.length === newArray?.length
            ? true
            : false;
        if (isCmValueFound) {
          valuesToRemove.push(...eachData.dependent_content_type_id);
        } else {
          valuesToAdd.push(...eachData.dependent_content_type_id);
        }
      }
    });

    let cmData: any = {
      valuesToAdd: valuesToAdd,
      valuesToRemove: valuesToRemove,
    };
    return cmData;
  };

  /**
   * @Name - getSelectedData
   * @Desc - This is used to find user response from options list
   *          and send to store.
   */
  getSelectedData = () => {
    let responseData: Object = {};
    let recoValue: Array<String> = [];
    let values: Array<String> = [];
    const selectedNeedStates: any = _.compact(this.state.selectedValues);
    _.map(selectedNeedStates, (data) => {
      recoValue.push(data.id);
      values.push(data.value);
    });
    responseData = {
      contentTypeId: this.props.contentTypeId,
      recoId: this.props.recoId,
      recoValues: recoValue,
      values: values,
    };
    setUserResponse(responseData);
    return responseData;
  };

  /**
   * This method is used for handleAsking Popup open
   *
   */
  handlePopup = () => {
    this.setState({
      isPopupOpen: true,
    });
  };

  /**
   * This method is used for handle Why Asking Popup close
   *
   */
  closePopup = () => {
    this.setState({
      isPopupOpen: false,
    });
  };

  /**
   * This method is used to handle checkbox click
   * @param {any} evt
   * @param {string} value
   *
   *
   */
  handleCheckbox = (value: any, index: number, evt?: any) => {
    evt?.stopPropagation();
    if (evt && evt.charCode === 32) {
      return;
    }
    const { optionsList, selectedValues } = this.state;
    //const isChecked = evt.target.checked;
    const data: any = optionsList;
    // const objIndex = data.findIndex((obj: any) => obj === value);
    data[index].isChecked = !data[index].isChecked;
    const filteredOptionsFalse = data.filter(
      (obj: any) => obj.isChecked === false
    ).length;
    if (filteredOptionsFalse !== data.length) {
      this.setState({
        isError: false,
      });
    }
    /*Code for setting the priority of need states*/
    if (data && data[index].isChecked === true) {
      this.setState(
        {
          selectedValues: [...this.state.selectedValues, value],
        },
        () => {
          /*code for setting null for remaining states if more than 1 need state is selected */
          let needStateValues: any = [...this.state.selectedValues];
          needStateValues = _.compact(needStateValues);
          if (needStateValues.length > 0 && needStateValues.length < 3) {
            for (let i = needStateValues.length; i < 3; i++) {
              needStateValues.push(null);
            }
          }
          this.setState({ selectedValues: needStateValues });
        }
      );
    } else {
      const selectedNeedStates = selectedValues;
      let indexOfItem = selectedNeedStates.indexOf(value);
      if (indexOfItem > -1) {
        selectedNeedStates.splice(indexOfItem, 1);
      }
      this.setState({ selectedValues: selectedNeedStates }, () => {
        let needStateValues: any = [...this.state.selectedValues];
        needStateValues = _.compact(needStateValues);
        if (needStateValues.length > 0 && needStateValues.length < 3) {
          for (let i = needStateValues.length; i < 3; i++) {
            needStateValues.push(null);
          }
        }
        this.setState({ selectedValues: needStateValues });
      });
    }
    const filteredOptionsLength = data.filter(
      (obj: any) => obj.isChecked === true
    ).length;

    /*Code for disabling the remaining options after 3 options are selected*/
    if (filteredOptionsLength === 3) {
      data &&
        data.forEach((element: any) => {
          if (element.isChecked === false) {
            element.isDisabled = true;
          }
        });
    } else {
      data &&
        data.forEach((element: any) => {
          element.isDisabled = false;
        });
    }
    this.setState({ optionsList: data });
  };
  /**
   * This method is used to remove need state
   * @param {any} item
   *
   */
  handleRemoveOnKeyPress = (event: any, item: any) => {
    if (event.key === "Enter" || event.key === " ") {
      this.handleRemove(item);
    }
  };

  handleRemove = (item: any) => {
    const { selectedValues, optionsList } = this.state;
    const selectedNeedStates = selectedValues;
    let indexOfItem = selectedNeedStates.indexOf(item);
    if (indexOfItem > -1) {
      selectedNeedStates.splice(indexOfItem, 1);
    }
    const data: any = optionsList;
    const objIndex = data.findIndex((obj: any) => obj === item);
    data[objIndex].isChecked = false;
    const filteredOptionsLength = data.filter(
      (obj: any) => obj.isChecked === true
    ).length;
    if (filteredOptionsLength === 3) {
      data &&
        data.forEach((element: any) => {
          if (element.isChecked === false) {
            element.isDisabled = true;
          }
        });
    } else {
      data &&
        data.forEach((element: any) => {
          element.isDisabled = false;
        });
    }
    this.setState(
      { selectedValues: selectedNeedStates, optionsList: data },
      () => {
        let needStateValues: any = [...this.state.selectedValues];
        needStateValues = _.compact(needStateValues);
        if (needStateValues.length > 0 && needStateValues.length < 3) {
          for (let i = needStateValues.length; i < 3; i++) {
            needStateValues.push(null);
          }
        }
        this.setState({ selectedValues: needStateValues });
      }
    );
  };

  render() {
    const { questionTitle, questionSubTitle, errorMsg, whyQuestionList } =
      this.props;
    const { optionsList, selectedValues, isError } = this.state;

    return (
      <div className="inner-wrapper mutiple-selection-container">
        <WhyAskingPopup
          {...this.props}
          open={this.state.isPopupOpen}
          close={this.closePopup}
          list={whyQuestionList}
        />
        <div className="question-wrappper">
          <div className="question-label">{questionTitle || ""}</div>
          <div className="question-sub-label">{questionSubTitle || ""}</div>
        </div>
        {selectedValues && selectedValues.length > 0 ? (
          <div className="ranking-cards">
            <div className="ranking-lists">
              {selectedValues.map((item: any, index: any) =>
                item === null ? (
                  <div className="ranking-wrapper disable">
                    <div className="ranking"></div>
                    <div className="ranking-label">
                      {this.props.t("common.wellness_area")} {index + 1}
                    </div>
                  </div>
                ) : (
                  <div
                    tabIndex={0}
                    className="ranking-wrapper"
                    onClick={() => this.handleRemove(item)}
                    onKeyPress={(e) => this.handleRemoveOnKeyPress(e, item)}
                  >
                    <div className="ranking">
                      <div className="ranking-count">{index + 1}</div>
                      <img
                        width="30px"
                        height="30px"
                        src={item && item.imageSrc}
                        alt="not available"
                      />
                    </div>
                    <div className="ranking-label">{item && item.value}</div>
                  </div>
                )
              )}
            </div>
          </div>
        ) : null}
        {/* Multiple answer inner wrapper Start */}
        <div className="multiple-answer-wrapper">
          <div className="answer-list-conatiner">
            <div className="checkbox-container checkbox-grid-layout">
              {optionsList && optionsList.length > 0
                ? optionsList.map((item: any, index: number) => (
                    <div
                      key={index}
                      tabIndex={0}
                      role="listitem"
                      className={
                        item && item.isDisabled
                          ? "checkbox-wrapper disable"
                          : item && item.isChecked
                          ? "checkbox-wrapper active"
                          : item && item.isMandatory === "true"
                          ? "checkbox-wrapper mandatory"
                          : isError
                          ? "checkbox-wrapper checkbox-error"
                          : "checkbox-wrapper"
                      }
                      onClick={() => this.handleCheckbox(item, index)}
                      onKeyPress={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          this.handleCheckbox(item, index, e);
                        }
                      }}
                    >
                      <CheckBox
                        className={
                          "checkbox"
                          // isError ? "checkbox checkbox-error" : "checkbox"
                        }
                        onCheckboxClick={(evt) =>
                          this.handleCheckbox(item, index, evt)
                        }
                        isChecked={
                          item && item.isMandatory === "true"
                            ? true
                            : item && item.isChecked
                        }
                      />
                      <div
                        className={
                          item && item.isChecked
                            ? "list-label active"
                            : "list-label"
                        }
                      >
                        {item.value || ""}
                      </div>
                      {/* <div className="icon custom-icon"></div> */}
                    </div>
                  ))
                : null}
            </div>
          </div>
          <div className={isError ? "error-msg" : "hide"}>
            {errorMsg && errorMsg.empty_error}
          </div>
        </div>
        {/* Multiple answer wrapper Ends */}

        {whyQuestionList && whyQuestionList.length > 0 ? (
          <WhyAskingComponent {...this.props} handlePopup={this.handlePopup} />
        ) : null}
      </div>
    );
  }
}

export default RankingSelectionComponent;
